/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';
import { format, subDays, addDays } from 'date-fns';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ButtonAction from '../../../components/ButtonAction/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';
import { Link } from 'react-router-dom';

const FlagHistoryList = () => {
  document.title = 'Enermerco - Histórico de Bandeiras';

  const [isLoading, setIsLoading] = useState(true);

  const [subClassList, setSubClassList] = useState([]);

  const [idDm010, setIdDm010] = useState('');
  const [flagHistoryDate, setFlagHistoryName] = useState('');
  const [dateFrom, setDateFrom] = useState(format(subDays(new Date(), 730), 'yyyy-MM-dd'));
  const [dateTo, setDateTo] = useState(format(addDays(new Date(), 365), 'yyyy-MM-dd'));

  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const applyFilter = (idDm010, dateFrom, dateTo) => {
    let url = 'flag_history?';
    if (idDm010 !== '') {
      url += `&id=${idDm010}`;
    }
    if (dateFrom !== '' && dateTo !== '') {
      url += `&date_from=${dateFrom}&date_to=${dateTo}`;
    }
    api
      .get(url)
      .then((response) => {
        setSubClassList(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = useCallback(() => {
    applyFilter(idDm010, dateFrom, dateTo);
  }, [idDm010, dateFrom, dateTo]);

  const cleanFields = useCallback(() => {
    setIdDm010('');
    setDateFrom(format(subDays(new Date(), 730), 'yyyy-MM-dd'));
    setDateTo(format(addDays(new Date(), 365), 'yyyy-MM-dd'));
    applyFilter('', '', '');
  }, [idDm010, flagHistoryDate]);

  const deleteFlagHist = useCallback(
    (id) => {
      api
        .delete(`flag_history?id=${id}`)
        .then((response) => {
          setModalDelete(false);
          if (response.status === 200) {
            toast.success('Histórico de Bandeira removido com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          cleanFields();
          setModalDelete(false);
          toast.success(error);
        });
    },
    [modalDelete]
  );

  useEffect(() => {
    applyFilter(idDm010, dateFrom, dateTo);
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${month}/${year}`;
  };

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Histórico de Bandeiras...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerStudies>
            <h2>Histórico de Bandeiras</h2>
            <Link to="./../add">
              <ButtonDefault Width={'150px'} Margin={'0px 30px 30px 0px'} Text="Adicionar" />
            </Link>
            <h3>Filtros</h3>
            <Row>
              <Col xs={2}>
                <InputDefault
                  placeholder="Código"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Código'}
                  value={`${idDm010}`}
                  onChange={(e) => setIdDm010(e.target.value)}
                />
              </Col>
              <Col xs={2}>
                <InputDefault
                  placeholder="Data de"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Data de'}
                  type="date"
                  value={`${dateFrom}`}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Col>
              <Col xs={2}>
                <InputDefault
                  placeholder="Data até"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Data até'}
                  type="date"
                  value={`${dateTo}`}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Col>
            </Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Buscar"
              onClick={searchFilter}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Limpar"
              onClick={() => {
                cleanFields();
              }}
            />
            <Table striped bordered hover variant="light">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                  <th style={{ width: '5%' }}>Competência</th>
                  <th style={{ width: '20%' }}>Bandeira</th>
                  <th style={{ width: '10%', textAlign: 'right' }}>Valor Adicional</th>
                  <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {subClassList.map((flagHist) => (
                  <tr>
                    <td style={{ textAlign: 'right' }}>{flagHist.ID_DM010}</td>
                    <td>{formatDate(flagHist.DT_COMPETENCIA)}</td>
                    <td>{`${flagHist.NM_BANDEIRA} (${flagHist.ID_DM004})`}</td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(flagHist.VL_ADICIONAL_BANDEIRA).toFixed(2).replace('.', ',')}
                    </td>
                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '45px',
                        justifyContent: 'center'
                      }}>
                      <Link to={`./../edit/${flagHist.ID_DM010}`}>
                        <ButtonAction Action="Edit" />
                      </Link>
                      <ButtonAction
                        Action="Remove"
                        onClick={() => {
                          setIdDm010(flagHist.ID_DM010);
                          setModalDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalDelete}
            handleClose={() => setModalDelete(false)}
            handleConfirm={deleteFlagHist}
            handleCancel={() => setModalDelete(false)}
            modalTitleText={`Deseja excluir o Histórico #${idDm010}?`}
            id={idDm010}
          />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default FlagHistoryList;
